import { render, staticRenderFns } from "./player-selector.vue?vue&type=template&id=5618c7b2&scoped=true"
import script from "./player-selector.vue?vue&type=script&lang=js"
export * from "./player-selector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5618c7b2",
  null
  
)

export default component.exports